import type { StatusExperiencia } from "../types";

/**
 * Codificação por forma (glifo) + rótulo, nunca só cor — e nunca vermelho.
 * `sensivel` usa a família ardósia/lavanda (não erro): é um dado a respeitar,
 * não um fracasso. Reaproveita as classes .badge do app.
 */
const MAPA: Record<
  StatusExperiencia,
  { classe: string; glifo: string; rotulo: string }
> = {
  favorita: { classe: "badge-seguro", glifo: "★", rotulo: "favorita" },
  em_exploracao: { classe: "badge-teste", glifo: "◐", rotulo: "em exploração" },
  sensivel: { classe: "badge-recusado", glifo: "◍", rotulo: "sensível" },
  nao_usada: { classe: "badge-naooferecido", glifo: "◌", rotulo: "não usada" },
};

export function StatusExperienciaBadge({ status }: { status: StatusExperiencia }) {
  const m = MAPA[status];
  return (
    <span className={`badge ${m.classe}`}>
      <span className="glifo" aria-hidden>
        {m.glifo}
      </span>
      {m.rotulo}
    </span>
  );
}
